<template>
<div class="dashboard-right-status">
	<div class="dashboard-list-top" style="position:relative;">

		<div class="countdown-bar__wrapper"><div id="countdownBar" v-if="showCountdownBar" :key="'countdownbar-'+countdownKey" class="countdown-bar animate"></div></div>
        <div class="container-fluid" :style="{  zIndex: 100 }" >
            <div class="row">
                <div class="col-sm-7 col-md-8 col-8 left-side  header-controls"  >
                        <div class="dashboard-list-header" style="z-index: 700;" >
                                        <span class="listTitle"><h2>Media Calls <span class="newMediaCallCount" v-if="newMediaCallCount > 0">+{{newMediaCallCount}}</span></h2></span>
                         </div>
                  </div>
              <div class="col-sm-5 col-md-4 col-4 text-right right-side  header-controls">
                        <div class="logo-user"><div class="header__notification">
                            <div class="float-right"><img src="/images/logo.svg?e0b2ae29f7aea7fcaf0153e097df8ceb" class="logo"></div>
                        </div></div>

              </div>
        </div>
        </div>
    </div>
    <div>
  </div>
<div class="dashboard-list-listing-wrapper">

<div id="dashboard-listing" :class="dashboardListingClass()" v-if="isLoaded">

	<div id="global-spinner" v-if="loading" style="left:66.5%; border:none; background:transparent;">
	  <b-spinner label="Loading"></b-spinner>
	</div>

    <div  style="z-index: 1;" id="allList01" class="dashboard-right-item clearfix" v-if="totalCount > 0">
<!-- component start -->

      <swiper :style="swiperCSS" id="swiper__media-calls" @slide-change-start="slideChangeStart" ref="swiper"  :speed=1000  direction="vertical" :key="'swiper'+swiperKey">
          <div v-for="n in totalPage" :key="n" :id="'deList'+n" class="swiper-row">
                  <masonry
                  :cols="{default: 2, 1500: 1, 700: 1}"
                  :gutter="5"
                 >
                        <div  style="z-index: -1;"  :style="{  zIndex: 0 }" class="dashboard-list-block" v-for="(deliverable, index) in deliverablesArray.slice( (n-1)*PageCountOfSwiper ,n*PageCountOfSwiper)"
                             :key="'deliverable'+index" :id="'de'+index">
                                <div class="d-flex flex-row dbox-wrapper">
                                    <div class="dbox-left-side dleft-inner-wrap">
                                        <div class="top-row">
                                            <template>
                                                <div class="data-status-items hide-mobile" 
                                                 :style="{backgroundColor:getDeliverableStatusColor(deliverable.status)}">
                                                    <span class="">{{ getDeliverableStatusName(deliverable.status) }}</span>
                                                </div>
                                            </template>
                                            <div  class="data-items">
                                                <span>
                                                    {{timeTitle(deliverable.all_completed)}}: {{runningTime(deliverable)}}
                                                </span>
                                            </div>

                                        </div>

                                        <div class="row listing-row">
                                            <div class="col-md-11 titles breakpoint__fix" :style="infoColStyle(deliverable)">
                                            	<template v-if="deliverable.title != 'Media call'">
                                                <div :class="`dashboard-list-title`" v-if="deliverable.title.length < 45">
                                                    {{ deliverable.title }}
                                                </div>
                                                 <div :class="`dashboard-list-title`" v-else>
                                                    {{ deliverable.title }}
                                                </div>

                                                <div v-if="showDepartment(deliverable)">
                                                    <div  v-if="deliverable">
                                                        <div
                                                            class="department-title exclude-outside-click"
                                                            v-for="(department, index) in deliverable.departments"
                                                            :key="'deliverable-modal-department-'+department.id"
                                                        >
                                                            <span style="color: 'var(--hover-grey)'" v-if="index > 0">&nbsp;&</span> {{ department.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="_.filter(deliverable.customFields, {field_key: 'questions'}).length==0">
                                                    <b-carousel
                                                        id= "index"
                                                        no-animation
                                                        :interval="8000"
                                                        controls
                                                        img-blank

                                                        @sliding-start="onSlideStart"
                                                        @sliding-end="onSlideEnd"
                                                        >
                                                        <!-- Slide with blank fluid image to maintain slide aspect ratio -->
                                                        <b-carousel-slide caption="" img-blank img-alt="Blank image">
                                                                <div  :ref="'totalSlide-'+n+'-'+index" :id="'totalSlide-'+n+'-'+index"> No questions have been entered. </div>
                                                        </b-carousel-slide>

                                                    </b-carousel>
                                                </div>
                                                <div v-for="(field,index2) in _.filter(deliverable.customFields, {field_key: 'questions'})" :key="index2">

                                                     <div class="dashboard-list-content"  v-html="strippedContent(field.value,1)"></div>

                                                <b-carousel
                                                    id= "index"
                                                    no-animation
                                                    :interval="8000"
                                                    controls
                                                    indicators
                                                    v-if="false"
                                                    img-blank

                                                    @sliding-start="onSlideStart"
                                                    @sliding-end="onSlideEnd"
                                                    >
                                                    <!-- Slide with blank fluid image to maintain slide aspect ratio -->
                                                    <b-carousel-slide caption="" img-blank img-alt="Blank image" v-for="nn in setSlidingArray(field.value)" :key="nn">
                                                            <div  :ref="'totalSlide-'+n+'-'+index" :id="'totalSlide-'+n+'-'+index" :data-value="setSlidingArray(field.value)" v-html="strippedContent(field.value, nn)"></div>
                                                    </b-carousel-slide>

                                                    </b-carousel>

                                                </div>
                                            <div v-if="false"  title="Delete" class="delete-bar" >
                                            </div>
                                        </template>
                                        <template v-else>
                                        	 <div :class="`dashboard-list-title`" >
                                        	    New media call being created.
                                        	</div>
                                        </template>
                                            </div>
                                            <div class="col-md-1 infos">
                                                <div class="d-flex flex-row">
                                                    <DeliverableStatusOverview :deliverable="deliverable"  v-if="!deliverable.all_completed" />
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="bottom-row"  :style="bottomRowStyle(deliverable.tasks)">
                                        </div>
                                    </div>
                                </div>
                          </div>
                    </masonry>
            </div>
    </swiper>
 <!-- component end -->
    </div>
    <div  style="z-index: 1;" id="allList01" class="dashboard-right-item clearfix" v-else-if ="totalCount == 0">
          <div class="dashboard-not-entry">
                Recent media calls will be displayed here.
        </div>
    </div>
    <div  style="z-index: 1;" id="allList01" class="dashboard-right-item clearfix" v-else>
<!-- component start -->
                  <masonry
                  :cols="{default: 2, 1500: 1, 700: 1}"
                  :gutter="5"
                 >
                        <div  style="z-index: -1;"  :style="{  zIndex: 0 }" class="dashboard-list-block" v-for="(deliverable, index) in deliverablesArray"
                             :key="'deliverable'+index" :id="'de'+index">
                                <div class="d-flex flex-row dbox-wrapper">
                                    <div class="dbox-left-side dleft-inner-wrap">
                                        <div class="top-row">
                                            <template>
                                                <div class="data-status-items hide-mobile" 
                                                 :style="{backgroundColor:getDeliverableStatusColor(deliverable.status)}">
                                                    <span class="">{{ getDeliverableStatusName(deliverable.status) }}</span>
                                                </div>
                                            </template>
                                            <div  class="data-items">
                                                <span>
                                                    {{timeTitle(deliverable.all_completed)}}: {{runningTime(deliverable)}}
                                                </span>
                                            </div>

                                        </div>

                                        <div class="row listing-row">
                                            <div class="col-md-11 titles breakpoint__fix" :style="infoColStyle(deliverable)">

                                                <div :class="`dashboard-list-title`" v-if="deliverable.title.length < 45">
                                                    {{ deliverable.title }}
                                                </div>
                                                 <div :class="`dashboard-list-title`" v-else>
                                                    {{ deliverable.title }}
                                                </div>

                                                <div v-if="showDepartment(deliverable)">
                                                    <div  v-if="deliverable">
                                                        <div
                                                            class="department-title exclude-outside-click"
                                                            v-for="(department, index) in deliverable.departments"
                                                            :key="'deliverable-modal-department-'+department.id"
                                                        >
                                                            <span style="color: 'var(--hover-grey)'" v-if="index > 0">&nbsp;&</span> {{ department.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                                 <div v-if="_.filter(deliverable.customFields, {field_key: 'questions'}).length==0">
                                                    <b-carousel
                                                        id= "index"
                                                        no-animation
                                                        :interval="8000"
                                                        controls
                                                        indicators

                                                        img-blank


                                                        >
                                                        <!-- Slide with blank fluid image to maintain slide aspect ratio -->
                                                        <b-carousel-slide caption="" img-blank img-alt="Blank image">
                                                                <div > No questions have been entered. </div>
                                                        </b-carousel-slide>

                                                    </b-carousel>
                                                </div>
                                                <div v-for="(field,index) in _.filter(deliverable.customFields, {field_key: 'questions'})" :key="index">
                                                <b-carousel
                                                    id= "index"
                                                    no-animation
                                                    :interval="8000"
                                                    controls
                                                    indicators

                                                    img-blank

                                                    @sliding-start="onSlideStart"
                                                    @sliding-end="onSlideEnd"
                                                    >
                                                    <!-- Slide with blank fluid image to maintain slide aspect ratio -->
                                                    <b-carousel-slide caption="" img-blank img-alt="Blank image" v-for="n in setSlidingArray(field.value)" :key="n">
                                                            <div class="" v-html="strippedContent(field.value, n)"></div>
                                                    </b-carousel-slide>

                                                    </b-carousel>
                                                </div>
                                            <div v-if="false" title="Delete" class="delete-bar">
                                            </div>
                                            </div>
                                            <div class="col-md-1 infos">
                                                <div class="d-flex flex-row">
                                                    <DeliverableStatusOverview :deliverable="deliverable"   v-if="!deliverable.all_completed" />
                                                </div>
                                            </div>
                                        </div>  
                                        <div class="bottom-row"  :style="bottomRowStyle(deliverable.tasks)">
                                        </div>
                                    </div>
                                </div>
                          </div>
                    </masonry>


 <!-- component end -->
    </div>
    </div>

</div>
</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import DeliverableStatusOverview from '../deliverables/DeliverableStatusOverview';

import Vue from "vue";

import VueMasonry from 'vue-masonry-css';
Vue.use(VueMasonry);

import $ from "jquery";

import { Swiper } from 'vue2-swiper';

export default {
    props: {
        statusData: {
            type: Object | Array,
            default: []
        },
    },
	data() {
		return {
			animateDistance:0,
			quarterHeight:250,
			halfHeight:500,
			fullHeight:1000,
			dashboardDeliverables:[],
			newMediaCallCount:0,
			spliceAmount:0,
			loading:false,
			swiperCSSOpacity:1,
			swiperCSSTop:0,
			startSlide:0,
			maxDays:14,
			addHoursToUTC:6,
			swiperCSS:"",
            filterQuery: {
                sort: "",
                query: "",
                filterByDate: false,
                filterByTaskDate: false,
                dateRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                taskDateRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                dateCompletedRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                filterByDateCreated : true,
                dateCreatedRange : {"startDate":"2022-08-11T05:00:00.942Z","endDate":"2022-08-12T05:00:00.942Z"},
                status: [],
                outlet: [],
                deliverableType: [],
                tag: [],
                department: [],
                coordinator: [],
                project: [],
                noDepartment: "not_accepted",
                noOutlet: "not_accepted",
                pageCount:100,
                weekFilterOptions: {
                    overdue: false,
                    today: false,
                    thisWeek: false,
                    nextWeek: false,
                    upcoming: false,
                    noDeadline: false,
                },
                dashboardType: 'list',
            },
            swiperKey:1,
            countdownKey:1,
            lastUpdated: new Date(),
            isOnLine:navigator.onLine,
            stringQuestion: null,
            timer: null,
            setTimerInterval: 10000,
            slide:0,
            sliding: null,
            slidingArray: [[]],
            questionSpliceCount:0,
            questionShowOrder:0,

            maxCount:0,
            slideCount:0,
            totalPage:0,
            listCountOfPage:0,
            PageCountOfSwiper:2,
            isLoaded:false,
            totalCount:0,
            swiperAutoplayTime:0,

            progressBarValue: 0,
            progressBarMaxValue: 50,
            swiperCurrentPageNumber:0,
            showCountdownBar:false,
		}
	},
	components: {
        DeliverableStatusOverview,
        Swiper,
	},
	computed: {
		...mapGetters([
			"allDeliverables",
            "getDeliverableTemplateSlug",
		]),

		deliverablesArray(n) {
			return this.dashboardDeliverables;
		},
		_() {
			return _;
		},

 	},
	methods: {
		...mapActions([
            "fetchPublicDeliverables",
		]),
        parseValue(str) {
            try {
                return JSON.parse(str);
            } catch (e) {
                console.error('Invalid JSON status:', e);
                return false;
            }
        },
        getDeliverableStatusColor(deliverableStatus) {
            if (deliverableStatus) {
                const statusObj = this.parseValue(deliverableStatus);
                if (statusObj) {
                    return statusObj.color;
                } else {
                    return 'var(--wf-secondary-tertiary-mix93)';
                }
            }
        },
        getDeliverableStatusName(deliverableStatus) {
            if (deliverableStatus) {
                let statusObj = this.parseValue(deliverableStatus);
                if (statusObj) {
                    return statusObj.name.toUpperCase();;
                } else {
                    return 'IN PROGRESS';
                }
            } else {
                return 'NOT STARTED';
            }
        },

        setSlidingArray: function(string){
            if ( string != null){
                let startNo = 330;
                let TstringQuestion = string.replaceAll("<p>&nbsp;</p>", "").replaceAll("&nbsp;", "").replaceAll(/<\/?span[^>]*>/g,"")
                TstringQuestion = TstringQuestion.replaceAll('<br/>I', 'I');
                TstringQuestion = TstringQuestion.replaceAll('<br/><br/>', '<br/>');
                TstringQuestion = TstringQuestion.replaceAll('<br/>', '_.');
                let count = Math.ceil(TstringQuestion.length / startNo);

                if ( count > this.maxCount){
                    this.maxCount = count;
                }

                return count;
            }
        },
        strippedContent: function(string, step) {
            if ( string != null){
                let startNo = 200;
                 startNo = 100000;
                let TstringQuestion = string.replaceAll("<p>&nbsp;</p>", "").replaceAll("&nbsp;", "").replaceAll(/<\/?span[^>]*>/g,"")
                TstringQuestion = TstringQuestion.replaceAll('<br/>I', 'I');
                TstringQuestion = TstringQuestion.replaceAll('<br/><br/>', '<br/>');

                TstringQuestion = TstringQuestion.replaceAll('<br/>', '_.');
                let count = Math.ceil(TstringQuestion.length / startNo);




                if( step == 1){
                    var r = TstringQuestion.substr(startNo*step, 50).indexOf(" ");
                    TstringQuestion =  TstringQuestion.slice(0,startNo*step+r);
                }else{
                    var r = TstringQuestion.substr(startNo*(step-1), 50).indexOf(" ");
                    var r2 = TstringQuestion.substr(startNo*step, 50).indexOf(" ");
                    TstringQuestion =  TstringQuestion.slice(startNo*(step-1)+r,startNo*step+r2);

                }
                if ( count > step){
                    TstringQuestion = TstringQuestion +  " <span class='question-next'>...</span>";
                }

                    TstringQuestion = TstringQuestion.replaceAll('_.', '<br/>');

                return TstringQuestion;
            }
        },

        dashboardListingClass() {
        	let className = "dashboard-list-listing ";
        	let maxHeightClass = "";
        	/*
        	1 - 4 =  full size
        	5 - 8 =  half height
        	9+ = quarter height (normal size)
        	*/
        	maxHeightClass = " quarter-height";

        	if (this.deliverablesArray.length <= 4) {
        		maxHeightClass = " full-height";
        	}
        	if (this.deliverablesArray.length > 4 && this.deliverablesArray.length <= 8) {
        		maxHeightClass = " half-height";
        	}

        	return className + maxHeightClass;
        },

        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        },
        parseJson(data) {
            try {
                return JSON.parse(data);
            } catch (e) {
                return data;
            }
        },
        taskColor(task) {
            let status = _.filter(task.taskFields, {field_key: 'status'});
            if(status.length) {
                return this.parseJson((status)[0].value).color;
            }
            return '';
        },

        bottomRowStyle(tasks) {
        	if (tasks) {
        		return "border-bottom:1px solid var(--wf-secondary-tertiary-mix93); border-left:1px solid var(--wf-secondary-tertiary-mix93);  border-right:8px solid "+ this.taskColor(tasks[tasks.length - 1])+"";
        	}
        	return null;
        },
        timeTitle(all_completed){
            if(all_completed){
                return "ELAPSED TIME";
            }else{
                return "RUNNING TIME";
            }
        },
        runningTime(deliverable){

             let returnRunningTime = "";
             let fromDate = Vue.moment().format("YYYY-MM-DD HH:mm")

            if (deliverable.all_completed){
                 fromDate = deliverable.completed_at;
            }
                let months = this.$moment.utc( this.$moment(fromDate, 'YYYY-MM-DD HH:mm').diff(this.$moment(deliverable.created_at, 'YYYY-MM-DD HH:mm').subtract(5, 'hours'))).format("M");
                let dd = this.$moment.utc( this.$moment(fromDate, 'YYYY-MM-DD HH:mm').diff(this.$moment(deliverable.created_at, 'YYYY-MM-DD HH:mm').subtract(5, 'hours'))).format("D");
                let hh = this.$moment.utc( this.$moment(fromDate, 'YYYY-MM-DD HH:mm').diff(this.$moment(deliverable.created_at, 'YYYY-MM-DD HH:mm').subtract(5, 'hours'))).format("H");
                let mm = this.$moment.utc( this.$moment(fromDate, 'YYYY-MM-DD HH:mm').diff(this.$moment(deliverable.created_at, 'YYYY-MM-DD HH:mm').subtract(5, 'hours'))).format("m");

                if (months > 0){
                     months = months -1;
                    if ( months > 0 ) {
                        if ( months ==1){
                            returnRunningTime = returnRunningTime + " "+months + "  month";
                        }else{
                            returnRunningTime = returnRunningTime + " "+months + "  months";
                        }
                    }
                }
                if ( dd > 0){
                    dd = dd -1;
                    if ( dd > 0) {
                        if ( dd == 1){
                            returnRunningTime = returnRunningTime + " "+dd + " day";
                        }else{
                            returnRunningTime = returnRunningTime + " "+dd + " days";
                        }
                    }
                }
                if ( hh > 0 ){
                    returnRunningTime = returnRunningTime + " "+hh+"h";
                }
                if ( mm > 0){
                    returnRunningTime = returnRunningTime + " "+mm+"min";
                }


                if (returnRunningTime == "") {
                	let ss = this.$moment.utc( this.$moment(fromDate, 'YYYY-MM-DD HH:mm:ss').diff(this.$moment(deliverable.created_at, 'YYYY-MM-DD HH:mm:ss').subtract(5, 'hours'))).format("s");
                	if (ss > 0) {
                		if (ss == 1) {
                			returnRunningTime = returnRunningTime + " "+ss+" second";
                		} else {
	                    	returnRunningTime = returnRunningTime + " "+ss+" seconds";
	                    }
                	}
                }




                return returnRunningTime;
        },

    slideChangeStart(number){
    		this.countdownKey++;
            this.swiperCurrentPageNumber = number;
            this.progressBarValue = 0;
            this.showCountdownBar = true;
            clearInterval(this.timer);

            // reset the animation of the countdown bar.
            const elm = document.getElementById("countdownBar");
            if (elm) {
	            var newone = elm.cloneNode(true);
	            elm.parentNode.replaceChild(newone, elm);
	        }

            this.timer = setTimeout(this.setSwiperTimer, this.setTimerInterval);
    },


    updateSwiperStyle() {
    	let css = "opacity:" + this.swiperCSSOpacity + ";";
    	this.swiperCSS = css;
    },

    swiperNext(){


           if ( this.swiperCurrentPageNumber < this.totalPage && this.totalPage > 1 ){
	           	this.showCountdownBar = true;
               if (this.$refs) {
                   this.$refs.swiper.next();
               }
           }else{
            	this.animateAway();

	           	this.showCountdownBar = false;
	           	this.$nextTick(() => {
		           	this.showCountdownBar = false;
	           	});

               let that = this;
               this.loading = true;
               setTimeout(function(){
                    that.reload();
                }, 0);


           }
    },

    setSwiperTimer(){
    	this.swiperNext();
    },

		infoColStyle(deliverable) {
			if (deliverable.title == "Media call") {
				return " ";
			}
			// Unused for now
            const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			if (deliverableTemplateSlug == "project-deliverable") {
				// return 'min-height:96px';
				return '';
			} else {
				return null;
			}
		},
		showDepartment(deliverable) {
            const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},

		animateAway() {
			let y = 0;
			y = this.quarterHeight;
			if (this.deliverablesArray.length <= 4) {
				y = this.fullHeight;
			}
			if (this.deliverablesArray.length > 4 && this.deliverablesArray.length <= 8) {
				y = this.halfHeight;
			}
			this.animateDistance = y;

			// Get the transformation matrix and slide the swiper wrapper up one more position.
			var object = $(".swiper-wrapper");
			var transMatrix = object.css("-webkit-transform") ||
			                  object.css("-moz-transform") ||
			                  object.css("-ms-transform") ||
			                  object.css("-o-transform") ||
			                  object.css("transform");
			if (transMatrix) {
				var values = transMatrix.match(/[\-\d\.]+(?=[,)])/g);
				let distance = parseInt(values[5]) - this.animateDistance;
				$(".swiper-wrapper").css("transform", "translate3d(0px, " + distance + "px, 0px)");
				$(".swiper-wrapper").css("transition-duration", "1000ms");
			}
		},
		animateBack() {
			// Don't need to animate back...
		},

    async reload(){
    	let that = this;
    	this.loading = true;
		this.showCountdownBar = false;
		that.countdownKey++;
		if (this.countdownKey > 30) {
			this.countdownKey = 1;
		}
    	let fromDate = this.$moment.utc().subtract(this.maxDays, 'days');
    	let endDate = this.$moment.utc().add(this.addHoursToUTC, 'hours');
    	this.filterQuery.dateCreatedRange.startDate = fromDate.format();
    	this.filterQuery.dateCreatedRange.endDate = endDate.format();
         this.$store.commit("setDashboardMediaCallsFilter", this.filterQuery);
        await this.fetchPublicDeliverables(1);

        this.$nextTick(() => {this.newMediaCallCount = 0;
        	this.newMediaCallCount = 0;
        });


        this.swiperCSSOpacity = 0;
        this.updateSwiperStyle();

        setTimeout(function() {
	        if ( that.timer != null){
	           clearInterval(that.timer);
	        }

            if (JSON.stringify(that.dashboardDeliverables) === JSON.stringify(that.allDeliverables)) {
            	// we're all good.
            } else {
    	        that.dashboardDeliverables = _.cloneDeep(that.allDeliverables)
    	    }

	        that.totalCount = that.deliverablesArray.length;
	        that.totalPage= Math.ceil(that.totalCount/ that.PageCountOfSwiper);
	        that.swiperKey++;
	        if (that.swiperKey > 30) {
	        	that.swiperKey = 1;
	        }
       		that.animateBack();
	    },500);

        setTimeout(function() {
        	that.swiperCSSOpacity = 1;
        	that.updateSwiperStyle();
			that.slideChangeStart(that.startSlide);
			that.loading = false;
	    },1000);



        this.lastUpdated = new Date();
        this.$emit("lastUpdated", this.lastUpdated);

         },
	},


	async mounted() {
        this.filterQuery.deliverableType = this.statusData.dashboardFilter.deliverableType;
        this.filterQuery.status = this.statusData.dashboardFilter.status;

		let fromDate = this.$moment.utc().subtract(this.maxDays, 'days');
		let endDate = this.$moment.utc().add(this.addHoursToUTC, 'hours');
		this.filterQuery.dateCreatedRange.startDate = fromDate.format();
		this.filterQuery.dateCreatedRange.endDate = endDate.format();

        this.$store.commit("setDashboardMediaCallsFilter", this.filterQuery);

        await this.fetchPublicDeliverables(1);
        this.totalCount = this.deliverablesArray.length;
        this.totalPage= Math.ceil(this.totalCount/ this.PageCountOfSwiper);

       this.lastUpdated = new Date();
        this.$emit("lastUpdated", this.lastUpdated);

        this.$nextTick(() => {
            this.slideChangeStart(this.startSlide);
       })
        this.isLoaded = true;


		Echo.channel('deliverable').listen('DeliverableCreated', (e) => {
            this.newMediaCallCount++;
		})
        .error((error) => {
                console.error("Error", error);
        });

	},
};
</script>
<style>

#swiper__media-calls {
	transition: opacity 1s;
	opacity:1;
}

</style>
